module.exports = __webpack_public_path__ + "static/img/animales_26.0d7d2056.jpeg";